import { useState } from "react";

import { useQuery } from "@tanstack/react-query";

import { Button, Grid2, Stack, Typography } from "@mui/material";
import { IconUserPlus } from "@tabler/icons-react";

import ContainerLoading from "../components/ContainerLoading";

import PageHeader from "../components/PageHeader";
import ResponsibleTableComponent from "../components/ResponsibleTableComponent";

import ResponsibleRegister from "../components/ResponsibleRegister";
import { listParents } from "../services/parents";

const Responsible = () => {
  const [open, setOpen] = useState(false);

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["listParents"],
    queryFn: async () => await listParents({}),
    initialData: [],
  });

  const refetchAll = () => {
    refetch();
  };

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Responsáveis"
          subtitle="Informações gerais dos responsáveis."
          options={
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: { xs: "flex-start", lg: "flex-end" },
                gap: 2,
              }}
            >
              <Button
                variant="contained"
                sx={{ gap: 0.5 }}
                onClick={() => setOpen(true)}
              >
                <IconUserPlus size={18} />
                <Typography variant="body2">Cadastrar Responsável</Typography>
              </Button>
            </Stack>
          }
        />

        <Grid2 size={12}>
          <Grid2 container spacing={2}>
            <Grid2 size={12}>
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              ></Stack>
            </Grid2>
            <Grid2 size={12}>
              <ResponsibleTableComponent
                data={data}
                refetch={() => refetchAll()}
              />
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>

      {open && (
        <ResponsibleRegister
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          refetch={refetch}
        />
      )}
    </ContainerLoading>
  );
};

export default Responsible;
